import type { FlowCompletionSummary, FlowRequirements } from "./types/flow-instances";

/**
 * QL-676 — project the full requirements picture onto the lean shape the web
 * wizards read. Builds the object field by field, so a full `FlowRequirements`
 * (e.g. a 422 gate body) never carries `steps` into a completion cache.
 */
export function toFlowCompletionSummary(requirements: FlowRequirements): FlowCompletionSummary {
  return {
    percent: requirements.percent,
    totalRequired: requirements.totalRequired,
    filledRequired: requirements.filledRequired,
    missing: requirements.missing,
    definitionUpdatedAt: requirements.definitionUpdatedAt,
  };
}
